import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import colors from '@settings/styleSettings'

import TextInput from '@components/inputs/textInput'
import SecondaryButton from '@components/inputs/button/secondaryButton'

import { WindowContext } from '@components/windowContextProvider'

import 'material-icons/iconfont/outlined.css'

import { Container, SearchContainer, SearchIcon } from './styles'

const CompaniesFilter = ({ searchTerm, onSearch, onInputChange }) => {
  const { clientWidth } = useContext(WindowContext)

  const inputBreak = clientWidth <= 490

  return (
    <Container>
      <SearchContainer>
        <TextInput
          placeholder="Digite parte do nome ou do CNPJ"
          value={searchTerm}
          onChange={onInputChange}
          style={{
            width: inputBreak ? '273px' : '393px',
            fontSize: inputBreak ? 12 : 14,
          }}
          onKeyDown={(e) => e.key === 'Enter' && onSearch()}
        />

        <SecondaryButton
          onClick={onSearch}
          style={{ backgroundColor: colors.background, width: '15px' }}
        >
          <SearchIcon className="material-icons-outlined">search</SearchIcon>
        </SecondaryButton>
      </SearchContainer>
    </Container>
  )
}

CompaniesFilter.propTypes = {
  searchTerm: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
}

CompaniesFilter.defaultProps = {
  searchTerm: '',
}

export default CompaniesFilter
